module.exports = __webpack_public_path__ + "static/media/logo.983e33ea.png";